import APITemplate from '@api/APITemplate'
import { diffTimeMinutes, formatQueryParams } from '@utils/Format'
import store from '@state/store'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import con from '@services/connection'
import { crm } from '@modules/crm/constants/URL'
import { informacoesCadastrais } from '@constants/URL'

class APICrmClients extends APITemplate {
  constructor() {
    super()

    this.reqCarregar = null
  }

  // eslint-disable-next-line max-statements
  async carregar({ forceUpdate = false, filters = null } = {}) {
    if (this.reqCarregar) {
      return this.reqCarregar
    }
    if (!forceUpdate) {
      if (
        !diffTimeMinutes(
          store.getters['crm/clientsLastUpdate'],
          MINUTES_TIMEOUT_REQUESTS
        )
      ) {
        return store.getters['crm/clients']
      }
    }

    if (store.getters['crm/clientsLoading']) {
      return store.getters['crm/clients']
    }

    store.dispatch('crm/setClientsLoading', true)

    const params = {}
    if (filters) {
      params.filters = JSON.stringify(filters)
    }

    this.reqCarregar = con.get(crm.clients + formatQueryParams(params))
    let r = await this.reqCarregar

    if (r && r.status === 200) {
      const data = r.value.grupos || []
      const summaryData = r.value.totais || {}
      store.dispatch('crm/setClients', data)
      store.dispatch('crm/setClientsSummary', summaryData)
    } else {
      store.dispatch('crm/setClients', [])
      store.dispatch('crm/setClientsSummary', {})
    }

    store.dispatch('crm/setClientsLoading', false)

    this.reqCarregar = null

    return r || {}
  }

  async changeFavorite({ item }) {
    if (!item) {
      return {
        status: 400,
        message: 'Dados inválidos.',
      }
    }

    const { id_cliente_app, id_favorito_profissional, favorito } = item

    const dado = {
      id_cliente_app,
    }

    const data = {
      data: JSON.stringify(dado),
    }

    let r

    if (favorito) {
      r = await con.post(crm.clientsFavorites, data)
    } else {
      r = await con.delet(crm.clientsFavorites + `/${id_favorito_profissional}`)
    }

    if (r && r.status === 200) {
      const value = r.value[0] || r.value || {}

      const payload = {
        id_cliente_app,
        favorito,
        id_favorito_profissional: value.id || id_favorito_profissional || null,
      }
      store.dispatch('crm/addClients', payload || {})
    }

    return (
      r || {
        status: 500,
        message: 'Erro ao mudar favorito.',
      }
    )
  }

  async salvar(dado) {
    const data = {
      data: JSON.stringify(dado),
    }

    let r

    if (dado.id && dado.id.length) {
      r = await con.put(crm.clients + `${dado.id}`, data)
    } else {
      r = await con.post(crm.clients, data)
    }

    if (r && r.status === 200) {
      this.carregar({ forceUpdate: true })
    }

    return r || {}
  }

  // Fetch de 1 cliente (id_cliente_app). Não dispara mutação — controller faz o upsert.
  async carregarCliente({ idClienteApp, filters = null } = {}) {
    if (!idClienteApp) {
      return {
        status: 400,
        message: 'Cliente inválido.',
      }
    }

    const params = {}
    const mergedFilters = {
      ...(filters && typeof filters === 'object' ? filters : {}),
      id_cliente_app: idClienteApp,
    }
    params.filters = JSON.stringify(mergedFilters)

    const r = await con.get(crm.clients + formatQueryParams(params))
    return (
      r || {
        status: 500,
        message: 'Erro ao carregar cliente.',
      }
    )
  }

  async carregarTags(force) {
    if (force) {
      const params = {
        only_tags: true,
      }

      const r = await con.get(crm.clients + formatQueryParams(params))

      if (r && r.status === 200) {
        const value = r.value || {}
        store.dispatch('crm/setClientsTags', value.tags_disponiveis || [])
      } else {
        store.dispatch('crm/setClientsTags', [])
      }

      return (
        r || {
          status: 500,
          message: 'Erro ao carregar tags.',
        }
      )
    }
  }

  async atualizarReguaRelacionamento({
    idClienteApp,
    idRegua,
    nomeRegua,
  } = {}) {
    if (!idClienteApp) {
      return {
        status: 400,
        message: 'Cliente inválido.',
      }
    }

    const payload = {
      id_cliente_app: idClienteApp,
      dados_cliente: JSON.stringify({
        id_regua: idRegua || null,
      }),
    }

    const response = await con.post(
      informacoesCadastrais.profissional_edit_client,
      payload
    )

    if (response && response.status === 200) {
      const value = response.value || {}
      const clienteData = value.cliente_data || {}
      const newRegua = clienteData.id_regua || null

      if (!newRegua) return response

      const storePayload = {
        id_cliente_app: idClienteApp,
        id_regua: newRegua,
        nome_regua: nomeRegua,
        relacionamento: {
          id_regua: newRegua,
          nome_regua: nomeRegua,
        },
      }

      store.dispatch('crm/addClients', storePayload || {})
      // Para crm/ClientsTasks não é necessário
    }

    return (
      response || {
        status: 500,
        message: 'Erro ao atualizar a régua do cliente.',
      }
    )
  }
}

const apiCrmClients = new APICrmClients()
export { apiCrmClients }
